<div class="overlay" [ngClass]="{ show: isVisible }" (click)="onClick()">
  <div class="trial">
    <div class="pictureContainer">
      <!-- Instruction text taking 20% of picture container height -->
      <div class="instruction-text">
        <p [innerHTML]="'若果你認為那張面孔表達某一種情緒，<br>請選擇這情緒的強烈程度。'"></p>
      </div>
      
      <!-- Three pictures taking 80% of picture container height -->
      <div class="pictures-container">
        <img src="assets/images/Instruction1.png" alt="Demo Image" />
        <img src="assets/images/Instruction2.png" alt="Demo Image" />
        <img src="assets/images/Instruction3.png" alt="Demo Image" />
      </div>
    </div>
    
    <div class="responseContainer">
      <!-- Non-interactable ngx-slider matching intensity-rating component exactly -->
      <div class="ratingContainer">
        <p class="instruction">這個情緒有多強烈？</p>

        <div class="sliderContainer">
          <div class="legend left">非常輕微</div>
          <div class="slider">
            <!-- Only render ngx-slider when component is visible -->
            <ngx-slider
              *ngIf="isVisible"
              [(value)]="value"
              [options]="options">
            </ngx-slider>
          </div>
          <div class="legend right">非常強烈</div>
        </div>
      </div>
    </div>
  </div>
</div> 